import { useQuery } from '@tanstack/react-query';
import { supportTicketServices } from '../services/support-ticket.service';

export const useTicket = (ticketId) => {
  return useQuery({
    queryKey: ['support-ticket', ticketId],
    queryFn: () => supportTicketServices.getTicketById(ticketId),
    enabled: !!ticketId,
    staleTime: 30 * 1000, // 30 seconds
    gcTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: true,
  });
};
